import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ToggleOn = (props) => (
  <Icon viewBox="0 0 8 6.2" {...props}>
    <g>
      <path d="M0 3.5c0 .2.2.4.3.5l2.8 2c.4.3.9.2 1.2-.2l3.5-4.6c.4-.2.3-.7-.1-1-.4-.3-.9-.2-1.2.1l-3 3.9-2.1-1.5C1 2.4.5 2.5.2 2.9c-.2.1-.2.4-.2.6z" className="st0"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default ToggleOn;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ToggleOn.js